export const en = {
    'period-from-to': '{from}–{to}'
};
